module.exports = __webpack_public_path__ + "img/complete_04.f8b463bd.png";